/**
 * Write / clear the `game_id` query param on `window.location`. Used when the
 * user picks a pack in the Lobby so the URL reflects the current game, making
 * the state visible for debugging, refresh-survivable, and link-shareable.
 *
 * Uses `replaceState` — URL updates without creating a new history entry.
 */
export function setGameIdInURL(gameId: string | null): void {
  const url = new URL(window.location.href);
  const current = url.searchParams.get('game_id');
  if (gameId) {
    if (current === gameId) return;
    url.searchParams.set('game_id', gameId);
  } else {
    if (current === null) return;
    url.searchParams.delete('game_id');
  }
  window.history.replaceState(null, '', url);
}
